import React from 'react';
import { FormControl, Select, MenuItem } from "@mui/material";

export default function NCRSelectField({ size = '', name, value, onChange, options, disabled, error, placeholder = "Select option", sx }) {
  return (
    <FormControl variant="outlined" error={error}>
      <Select
        sx={{
          fontSize: "14px",
          width: size === "medium" ? "340px" : "200px",
          height: "42px",
          fontFamily: 'Lato, sans-serif',
          "&.Mui-disabled .MuiSelect-select": {
            WebkitTextFillColor: "#000000 !important",
          },
          "& .MuiSelect-select": {
            userSelect: "text",
          },
          ...sx
        }}
        name={name}
        value={value || ""}
        disabled={disabled}
        onChange={onChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return (
              <span
                style={{
                  color: disabled ? "#000000" : "rgba(84, 84, 84, 1)",
                  fontSize: "14px",
                }}
              >
                {placeholder}
              </span>
            );
          }
          return selected;
        }}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{ disablePortal: true }}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option} className='dropdown-menu-item'>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
